import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { MarketDataProvider } from './context/MarketDataContext';
import ErrorBoundary from './components/ErrorBoundary';
import ProtectedRoute, { AdvisorRoute } from './components/ProtectedRoute';
import Nav from './components/Nav';
import Dashboard from './pages/Dashboard';
import PortfolioBuilder from './pages/PortfolioBuilder';
import Benchmarks from './pages/Benchmarks';
import History from './pages/History';
import AccountSettings from './pages/AccountSettings';
import HelpTour from './pages/HelpTour';
import ResetPassword from './pages/ResetPassword';
import Login from './pages/Login';
import ShareView from './pages/ShareView';
import InviteView from './pages/InviteView';
import ClientPortal from './pages/ClientPortal';
import Messages from './pages/Messages';
import MeetingScheduler from './pages/MeetingScheduler';
import ErrorLogs from './pages/ErrorLogs';
import DevDashboard from './pages/DevDashboard';
import { initErrorLogging } from './lib/errorLogger';

initErrorLogging();

export default function App() {
  return (
    <ErrorBoundary>
    <AuthProvider>
      <MarketDataProvider>
      <BrowserRouter>
        <div className="min-h-screen flex flex-col">
          <Nav />
          <main className="flex-1">
            <ErrorBoundary>
            <Routes>
              {/* Public */}
              <Route path="/login" element={<Login />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/share/:token" element={<ShareView />} />
              <Route path="/invite/:token" element={<InviteView />} />

              {/* Dev dashboard — no auth required */}
              <Route path="/dev" element={<DevDashboard />} />

              {/* Protected */}
              <Route element={<ProtectedRoute />}>
                <Route path="/" element={<Dashboard />} />
                <Route path="/settings" element={<AccountSettings />} />
                <Route path="/help" element={<HelpTour />} />
                <Route path="/client-portal" element={<ClientPortal />} />
                <Route path="/messages" element={<Messages />} />
                <Route path="/meetings" element={<MeetingScheduler />} />

                {/* Advisor-only routes — clients are redirected to /client-portal */}
                <Route element={<AdvisorRoute />}>
                  <Route path="/portfolio/new" element={<PortfolioBuilder />} />
                  <Route path="/portfolio/:id" element={<PortfolioBuilder />} />
                  <Route path="/benchmarks" element={<Benchmarks />} />
                  <Route path="/history" element={<History />} />
                  <Route path="/error-logs" element={<ErrorLogs />} />
                </Route>
              </Route>

              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
            </ErrorBoundary>
          </main>
        </div>
      </BrowserRouter>
      </MarketDataProvider>
    </AuthProvider>
    </ErrorBoundary>
  );
}
